import { useYearContext } from "../../hooks/useYearContext";
import SmallGameTV from "../../components/SmallGameTV";
import { useEffect, useState } from "react";
import { Game } from "../../types";

export default function TV() {
  const { current } = useYearContext();
  const [games, setGames] = useState<Game[]>([]);
  const [live, setLive] = useState<boolean>(true);
  const [time, setTime] = useState<number>(0);

  const getTime = async () => {
    const response = await fetch(`${process.env.REACT_APP_PATH}/api/game/changes`);
    const json: { time: string }[] = await response.json();
    if (response.ok) {
      if (time < new Date(json[0].time).valueOf()) {
        getGames();
        setTime(new Date(json[0].time).valueOf());
        console.log("A");
      } else {
        console.log("B");
      }
    } else {
      alert((json as any).error);
    }
  };

  const getGames = async () => {
    if (!current) return;

    const response = await fetch(`${process.env.REACT_APP_PATH}/api/game/live?year=${current.year}`);
    const json: Game[] = await response.json();
    if (response.ok) {
      setLive(json.length !== 0);

      const response2 = await fetch(`${process.env.REACT_APP_PATH}/api/game/upcoming?year=${current.year}`);
      const json2: Game[] = await response2.json();
      if (response2.ok) {
        setGames([...json, ...json2]);
        console.log([...json, ...json2]);
      } else {
        alert((json2 as any).error);
      }
    } else {
      alert((json as any).error);
    }
  };

  useEffect(() => {
    if (current && time === 0) {
      getTime();
    }
    const interval = setInterval(() => {
      if (current) {
        getTime();
        getGames();
      }
    }, 15000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current, time]);

  return (
    <div className="">
      <img src="\img\main_bg.jpg" alt="" className="absolute w-screen h-screen object-cover bg-black top-0 left-0 -z-10" />

      <div className="flex w-screen md:h-screen justify-center relative -z-10">
        <div className="w-1/2 flex flex-col justify-center items-center">
          <img src="/img/main_text.jpg" alt="" className="w-[45vw] z-10 object-contain" />
          <p className="text-black text-6xl font-semibold mt-8 underline">vht.3horky.sk</p>
        </div>

        {current !== undefined && (
          <div className="w-1/2 relative h-screen flex flex-col justify-around z-30">
            {current.status === "ongoing" && live && (
              <div className="md:flex flex-col justify-around md:w-[30vw] mx-auto">
                {games.length > 0 && (
                  <div className="w-4/5 md:w-full mx-auto md:mx-0 z-20">
                    {games.filter((e) => e.status === "live").length > 0 && (
                      <div className="bg-accent text-white text-center py-2 md:py-3">
                        <h2 className="font-medium text-3xl">Aktuálne hrané zápasy</h2>
                      </div>
                    )}
                    {games
                      .filter((e) => e.status === "live")
                      .map((e) => (
                        <SmallGameTV key={e.ID} e={e} className="" />
                      ))}
                  </div>
                )}
              </div>
            )}

            {current.status === "ongoing" && (
              <div className="md:flex flex-col justify-around md:w-[30vw] mx-auto">
                {games.length > 0 && (
                  <div className="w-4/5 md:w-full mx-auto md:mx-0 z-20">
                    {games.filter((e) => e.status === "scheduled").length > 0 && (
                      <div className="border border-accent bg-white text-accent text-center py-2 md:py-3">
                        <h2 className="font-medium text-3xl">Nasledujúce zápasy</h2>
                      </div>
                    )}
                    {games
                      .filter((e) => e.status === "scheduled")
                      .map((e) => (
                        <SmallGameTV key={e.ID} e={e} className="" />
                      ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
